import { render, staticRenderFns } from "./KwtBasicDropdown.vue?vue&type=template&id=bdf05b44&scoped=true&"
import script from "./KwtBasicDropdown.vue?vue&type=script&lang=js&"
export * from "./KwtBasicDropdown.vue?vue&type=script&lang=js&"
import style0 from "./KwtBasicDropdown.vue?vue&type=style&index=0&id=bdf05b44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf05b44",
  null
  
)

export default component.exports